export enum CssWidths {
  TEN = 'u-width-10',
  TWENTY = 'u-width-20',
  THIRTY = 'u-width-30',
  FORTY = 'u-width-40',
  FIFTY = 'u-width-50',
  SIXTY = 'u-width-60',
  SEVENTY = 'u-width-70',
  EIGHTY = 'u-width-80',
  NINETY = 'u-width-90',
  HUNDRED = 'u-width-100',
  THIRD = 'u-width-third'
}
